import * as React from "react";

import Api from "../Api";
import Type from "../definitions/Type";

import FlatButton from "material-ui/FlatButton";

interface NotificationDismissButtonProps {

    /** Notification type to whose the Action belongs */
    type: Type;

    /** Button Text */
    label: string;

    /** Notification Action object */
    onClick: () => void;

    /** Data Test Id for Selenium tests */
    testId?: string;

    /** Is it a dismiss Action or a delete Action? */
    isDismissDeletion?: boolean;

    /** Button CSS Styles */
    style?: React.CSSProperties;
}

export default class NotificationDismissButton extends React.Component<NotificationDismissButtonProps, {}> {

    handleClick = () => {
        Api.schedule(() => {
            if (this.props.isDismissDeletion) {
                Api.deleteOne(
                    this.props.type
                );
            } else {
                Api.pushOne({
                    type: this.props.type,
                    dismissed: true,
                    read: true
                });
            }
            if (typeof this.props.onClick === "function") {
                this.props.onClick();
            }
        });
    };

    render() {
        let testId = "notification-" + (this.props.testId ? this.props.testId : "dismiss");

        return (
            <FlatButton
                data-test-id={testId}
                label={this.props.label}
                style={this.props.style}
                onTouchTap={this.handleClick} />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/components/NotificationDismissButton.tsx
 **/